import React from "react"
import { useTranslation } from "react-i18next"

import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { formatDateNew } from "~/helpers/formatDate"

import styles from "./index.module.css"

type Props = {
  date: Date
  name: string
  file: string | null
  link?: string | null
}

export const TopCell: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Top}>
      <div>
        <Raw html={t("docs.Table.Title.01")} />
      </div>
      <div>
        <Raw html={t("docs.Table.Title.02")} />
      </div>
    </div>
  )
}

export const Cell: React.FC<Props> = ({ date, file, link, name }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.Item}>
      <div>
        <div className={styles.Title}>
          <Raw html={t("docs.Table.Title.01")} />
        </div>
        <div>{name}</div>
      </div>

      <div>
        <div className={styles.Title}>
          <Raw html={t("docs.Table.Title.02")} />
        </div>
        {formatDateNew(date, "dd.MM.yyyy")}
      </div>

      {file && !link && (
        <Link className={styles.Link} href={file} target="_blank" view="arrow">
          <Raw html={t("docs.Table.File")} />
        </Link>
      )}

      {link && (
        <Link className={styles.Link} href={link} target="_blank" view="arrow">
          <Raw html={t("docs.Table.Link")} />
        </Link>
      )}
    </div>
  )
}
